<template>
  <div>
      量表组合
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>